import { render, staticRenderFns } from "./ReservationLayout.vue?vue&type=template&id=3bae685c&"
import script from "./ReservationLayout.vue?vue&type=script&lang=ts&"
export * from "./ReservationLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports